import Api from "../constants/Api";
import HttpRequest from "./HttpRequest";


export const addTriggerFolderApi = async (payload) => {
  return HttpRequest.post(Api.triggerFolder, payload);
};

export const getTriggerFolderApi = async (payload) => {
  return HttpRequest.get(Api.triggerFolder, payload);
};

export const updateTriggerFolderApi = async (payload) => {
  return HttpRequest.put(Api.triggerFolder, payload);
};

export const deleteTriggerFolderApi = async (payload) => {
  return HttpRequest.delete(Api.triggerFolder, payload);
};

export const getTeamUsersApi = async (payload) => {
    return HttpRequest.post(Api.teamUserList, payload);
};

export const addTriggerApi = async (payload) => {
  return HttpRequest.post(Api.trigger, payload);
};

export const getTriggerApi = async (payload) => {
  return HttpRequest.get(Api.trigger, payload);
};

export const updateTriggerApi = async (payload) => {
  return HttpRequest.put(Api.trigger, payload);
};

export const deleteTriggerApi = async (payload) => {
  return HttpRequest.delete(Api.trigger, payload);
};

export const updateTriggerStatusApi = async (payload) => {
  return HttpRequest.post(Api.changeStatus, payload);
};

export const duplicateTriggerApi = async (payload) => {
  return HttpRequest.post(Api.duplicate, payload);
};

